import axios from "axios";

export default axios.create({
  baseURL: "https://api.gama-electronic.com/api/",
  headers: {
    "Content-type": "application/json"
  }
});